<ion-item class="card-content"
          tappable
          (click)="download(faqFile.id)"
          detail="false">
    <ion-icon slot="start" name="document"></ion-icon>
    <ion-text>
        <div>
            <div>Document lié</div>
            <div class="contactValue">{{faqFile.filename}}</div>
        </div>
    </ion-text>
    <ion-icon slot="end" color="secondary" name="arrow-forward"></ion-icon>
</ion-item>
